import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

export const useRefreshTokenTimer = () => {
  const expiryTime = useSelector(
    (store) => store.userReducer.refreshTokenExpiry
  );
  const [remaining, setRemaining] = useState(null); // Start with null

  useEffect(() => {
    if (!expiryTime) return;

    const tick = () => {
      const now = Date.now();
      const diff = expiryTime - now;

      if (diff <= 0) {
        setRemaining(0);
      } else {
        setRemaining(diff);
      }
    };

    tick();
    const timerId = setInterval(tick, 1000);
    return () => clearInterval(timerId);
  }, [expiryTime]);

  return remaining;
};